import { createField } from "./verify-identity-file.section";
import { createLoading } from "../../../utils/loading";
import { useForm as createUseForm } from "@ant-design-vue/use";

export const { isLoading, setIsLoading } = createLoading();

export const initForm = ({ props, data, refs }) => {
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
};
